import React, { useEffect, useRef } from 'react';
function useScrollReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
export function OneLiners() {
  const headerRef = useScrollReveal(0);
  const gridRef = useScrollReveal(200);
  return <section className="w-full py-20 sm:py-28" style={{
    backgroundColor: '#0f0f0f'
  }} aria-label="Words to live by" data-id="element-306">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-307">
        <div ref={headerRef} className="text-center mb-14" data-id="element-308">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-309">
            <div style={{
            width: '40px',
            height: '1px',
            background: '#C9A84C'
          }} data-id="element-310" />
            <span className="section-label" data-id="element-311">Words to Live By</span>
            <div style={{
            width: '40px',
            height: '1px',
            background: '#C9A84C'
          }} data-id="element-312" />
          </div>
          <h2 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
          fontWeight: 700,
          color: '#F5F5F5',
          lineHeight: 1.2
        }} data-id="element-313">
            The Truth About{' '}
            <span style={{
            color: '#C9A84C',
            fontStyle: 'italic'
          }} data-id="element-314">
              Looking Sharp
            </span>
          </h2>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-315">
          <OneLiner text="A bad cut doesn't just affect how you look — it affects how you feel all week." data-id="element-316" />
          <OneLiner text="Your barber should know your name. Not just your head size." data-id="element-317" />
          <OneLiner text="Real barbers don't need you to bring a photo. They listen." data-id="element-318" />
          <OneLiner text="You're not asking for a miracle. You're asking for what you paid for." data-id="element-319" />
          <OneLiner text="The right cut doesn't add confidence. It reveals it." data-id="element-320" />
          <OneLiner text="Close enough isn't a style. It's a disappointment." data-id="element-321" />
          <OneLiner text="A man who looks sharp walks differently. That's not vanity. That's power." data-id="element-322" />
          <OneLiner text="Your son is watching how you take care of yourself. Show him the standard." data-id="element-323" />
          <OneLiner text="No appointment means no excuses. Just show up and get taken care of." data-id="element-324" />
          <OneLiner text="You tip the barber every time. You deserve to leave smiling every time." data-id="element-325" />
        </div>
      </div>
    </section>;
}
function OneLiner({
  text
}: {
  text: string;
}) {
  return <div className="p-5 rounded-sm flex gap-4 items-start" style={{
    backgroundColor: '#111111',
    border: '1px solid rgba(201,168,76,0.12)'
  }} data-id="element-326">
      <div style={{
      flexShrink: 0,
      marginTop: '4px'
    }} data-id="element-327">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-328">
          <circle cx="12" cy="12" r="10" data-id="element-329" />
          <line x1="12" y1="8" x2="12" y2="12" data-id="element-330" />
          <line x1="12" y1="16" x2="12.01" y2="16" data-id="element-331" />
        </svg>
      </div>
      <p style={{
      fontFamily: 'var(--font-heading)',
      fontSize: '0.95rem',
      fontStyle: 'italic',
      color: '#cccccc',
      lineHeight: 1.65
    }} data-id="element-332">
        "{text}"
      </p>
    </div>;
}